import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigsService } from '../providers/configs.service';
import { SessionService } from '../providers/session.service';

@Injectable({
	providedIn: 'root'
})
export class UsuarioService {

	constructor(
		public http: HttpClient,
		public session: SessionService,
		public configs: ConfigsService
	) { }

	getUsuario(friendly_name, username, email, cliente, page) {
        friendly_name = (friendly_name == null || friendly_name == '') ? '' : '&friendly_name=' + friendly_name
        cliente = (cliente == null || cliente == '') ? '' : '&cliente=' + cliente
        username = (username == null || username == '') ? '' : '&username=' + username
        email = (email == null || email == '') ? '' : '&email=' + email
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'users?_page='+page + friendly_name + username + email + cliente)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        });
    }

    deleteUsuario(id) {
        return new Promise((resolve, reject) => {
            this.http.delete(this.configs.getEndpoint() + 'users/' + id)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        });
    }


    salvarUsuario(user) {
        return new Promise((resolve, reject) => {
            let body = user;

            this.http.post(this.configs.getEndpoint() + 'users', body)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        })
    }

    putusuario(usuario){
        console.log("usuario", usuario)
        return new Promise((resolve, reject) => {
            let body = usuario;
            this.http.put(this.configs.getEndpoint() + 'users/' + usuario['id'], body)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error);
                });
        });
    }

    getUsuariosByID(id) {
        console.log("get by id")
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'users/' + id)
                .subscribe(data => {
                    
                    resolve(data);
                    
                },
                error => {
                    reject(error);
                });
        });
    }

    resetSenha(id,senha) {
        return new Promise((resolve, reject) => {
            let body = {
                password: senha
            }
            this.http.patch(this.configs.getEndpoint() + 'users/' + id + '/change-password', body)
                .subscribe(data => {
                    resolve(data);
                    console.log(data)
                },
                error => {
                    reject(error)
                    console.log(error)
                });
        })
    }
}
